/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-29 14:39:15
 */
const msgRecharge = () => import("@/views/pile-manage/msg-manage/children/msg-server/children/msg-recharge/msg-recharge.vue");
const msgBuy = () => import("@/views/pile-manage/msg-manage/children/msg-server/children/msg-buy/msg-buy.vue");
const msgBuyRecordDetails = () => import("@/views/pile-manage/msg-manage/children/msg-buy-record/children/msg-buy-record-details/msg-buy-record-details.vue");
const msgApplyInvoice = () => import("@/views/pile-manage/msg-manage/children/msg-buy-record/children/msg-apply-invoice/msg-apply-invoice.vue");
const msgPurchase = () => import("@/views/pile-manage/msg-manage/children/msg-buy-record/children/msg-purchase/msg-purchase.vue");
const routerList = [
    {
        path: "/pile-manage/asset-overview",
        name: "资产概览",
        component: () => import("@/views/pile-manage/asset-overview/asset-overview.vue"),
    },
    {
        path: "/pile-manage/pile-info",
        name: "站点列表",
        component: () => import("@/views/pile-manage/pile-info/pile-info.vue"),
        children: [
            {
                path: "/pile-manage/pile-info/detail",
                name: "站点详情",
                component: () => import("@/views/pile-manage/pile-info/children/site-details/site-details.vue"),
                meta: {
                    nameKey: "siteDetails",
                },
            },
            {
                path: "/pile-manage/pile-info/import-table",
                name: "站点导入",
                component: () => import("@/views/pile-manage/pile-info/children/import-table/import-table.vue"),
                meta: {
                    nameKey: "siteImportTable",
                },
            },
            {
                path: "/pile-manage/pile-info/charge-strategy",
                name: "充电策略",
                component: () => import("@/views/pile-manage/pile-info/children/charge-strategy/charge-strategy.vue"),
                meta: {
                    nameKey: "chargeStrategy",
                },
            },
            {
                path: "/pile-manage/pile-info/oper-set",
                name: "运营设置",
                component: () => import("@/views/pile-manage/pile-info/children/oper-set/oper-set.vue"),
                meta: {
                    nameKey: "operSet",
                },
            },
            {
                path: "/pile-manage/pile-info/phone-show",
                name: "对外显示",
                component: () => import("@/views/pile-manage/pile-info/children/phone-show/phone-show.vue"),
                meta: {
                    nameKey: "phoneShow",
                },
            },
            {
                path: "/pile-manage/pile-info/all-updata-rate/charge",
                name: "批量更换充电费率",
                component: () => import("@/views/pile-manage/pile-info/children/all-charge-rate/all-charge-rate.vue"),
                meta: {
                    nameKey: "addRateTemplate",
                },
            },
            {
                path: "/pile-manage/pile-info/all-updata-rate/delay",
                name: "批量更换占桩费率",
                component: () => import("@/views/pile-manage/pile-info/children/all-delay-rate/all-delay-rate.vue"),
                meta: {
                    nameKey: "allUpdataRateChange",
                },
            },
            {
                path: "/pile-manage/pile-info/all-updata-rate/reservation",
                name: "批量更换预约费率",
                component: () => import("@/views/pile-manage/pile-info/children/all-reservation-rate/all-reservation-rate.vue"),
                meta: {
                    nameKey: "allUpdataReservation",
                },
            },
            {
                path: "/pile-manage/pile-info/charging-strategy",
                name: "有序充电策略",
                component: () => import("@/views/pile-manage/pile-info/children/charging-strategy/charging-strategy.vue"),
                meta: {
                    nameKey: "pileChargingStrategy",
                },
            },
            {
                path: "/pile-manage/pile-info/charging-strategy/charging-strategy-groups",
                name: "有序充电策略分组",
                component: () => import("@/views/pile-manage/pile-info/children/charging-strategy/children/charging-strategy-groups/charging-strategy-groups.vue"),
                meta: {
                    nameKey: "pileChargingStrategyGroups",
                },
            },
            {
                path: "/pile-manage/pile-info/edit",
                name: "编辑站点",
                component: () => import("@/views/pile-manage/pile-info/children/piles-up/piles-up.vue"),
                meta: {
                    nameKey: "editPiles",
                },
            },
            {
                path: "/pile-manage/pile-info/add",
                name: "新增站点",
                component: () => import("@/views/pile-manage/pile-info/children/piles-add/piles-add.vue"),
                meta: {
                    nameKey: "addPiles",
                },
            },
            {
                path: "/pile-manage/pile-info/site-debug",
                name: "现场调试",
                component: () => import("@/views/pile-manage/pile-info/children/site-debug/site-debug.vue"),
                meta: {
                    nameKey: "siteDebug",
                },
            },
            {
                path: "/pile-manage/pile-info/ele",
                name: "电价列表",
                component: () => import("@/views/pile-manage/pile-info/children/ele-list/ele-list.vue"),
                meta: {
                    nameKey: "elePiles",
                },
            },
            {
                path: "/pile-manage/pile-info/ele/rate-record",
                name: "费率更换明细",
                component: () => import("@/views/pile-manage/pile-info/children/rate-charge-record/rate-charge-record.vue"),
                meta: {
                    nameKey: "elePilesChargeRecord",
                },
            },
            {
                path: "/pile-manage/pile-info/audit",
                name: "站点审核",
                component: () => import("@/views/pile-manage/pile-info/children/pile-audit/pile-audit.vue"),
                meta: {
                    nameKey: "pileAudit",
                },
            },
        ],
    },
    {
        path: "/pile-manage/pile-list",
        name: "桩列表",
        component: () => import("@/views/pile-manage/pile-list/piles-list.vue"),
        children: [
            {
                path: "/pile-manage/pile-list/all-line-off-pile",
                name: "批量上线/下线",
                component: () => import("@/views/pile-manage/pile-list/children/all-line-off-pile/all-line-off-pile.vue"),
                meta: {
                    nameKey: "allLineOffPile",
                },
            },
            {
                path: "/pile-manage/pile-list/all-bind-pile",
                name: "批量关联站点",
                component: () => import("@/views/pile-manage/pile-list/children/all-bind-sta/all-bind-sta.vue"),
                meta: {
                    nameKey: "allBindPile",
                },
            },
            {
                path: "/pile-manage/pile-list/edit-gun",
                name: "编辑枪",
                component: () => import("@/views/pile-manage/pile-list/children/edit-gun/edit-gun.vue"),
                meta: {
                    nameKey: "editGun",
                },
            },
            {
                path: "/pile-manage/pile-list/pile-detail",
                name: "桩详情",
                component: () => import("@/views/pile-manage/pile-list/children/details-pile/details-pile.vue"),
                meta: {
                    nameKey: "detailsPile",
                },
            },
            {
                path: "/pile-manage/pile-list/all-updata",
                name: "批量编辑",
                component: () => import("@/views/pile-manage/pile-list/children/all-updata/all-updata.vue"),
                meta: {
                    nameKey: "pileAllUpdata",
                },
            },
            {
                path: "/pile-manage/pile-list/edit-pile",
                name: "编辑桩",
                component: () => import("@/views/pile-manage/pile-list/children/edit-pile/edit-pile.vue"),
                meta: {
                    nameKey: "editPile",
                },
            },
            {
                path: "/pile-manage/pile-list/add-pile",
                name: "新增桩",
                component: () => import("@/views/pile-manage/pile-list/children/add-pile/add-pile.vue"),
                meta: {
                    nameKey: "addPile",
                },
            },
        ],
    },
    {
        path: "/pile-manage/operation-data",
        name: "运营数据",
        component: () => import("@/views/pile-manage/operation-data/operation-data.vue"),
    },
    // {
    //   path: "/pile-manage/fee-manage",
    //   name: "费率管理",
    //   component: () => import("@/views/pile-manage/fee-manage/fee-manage.vue"),
    // },
    // {
    //   path: "/pile-manage/fee-manage/fee-station-detail",
    //   name: "交直流充电桩充电费率",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-manage/children/fee-station-detail/fee-station-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "feePileDetail",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/add-fee",
    //   name: "新增费率",
    //   component: () =>
    //     import("@/views/pile-manage/fee-manage/children/add-fee/add-fee.vue"),
    //   meta: {
    //     nameKey: "addFee",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/edit-fee",
    //   name: "编辑费率",
    //   component: () =>
    //     import("@/views/pile-manage/fee-manage/children/edit-fee/edit-fee.vue"),
    //   meta: {
    //     nameKey: "editFee",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/fee-record",
    //   name: "费率-记录",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-manage/children/fee-manage-record/fee-manage-record.vue"
    //     ),
    //   meta: {
    //     nameKey: "feePageRecord",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/fee-station-batch-change",
    //   name: "充电费率-批量更换费率",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-manage/children/fee-station-batch-change/fee-station-batch-change.vue"
    //     ),
    //   meta: {
    //     nameKey: "feeStationBatchChange",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/fee-price-updata",
    //   name: "企业费率-电价修改",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-manage/children/fee-price-updata/fee-price-updata.vue"
    //     ),
    //   meta: {
    //     nameKey: "entFeeUpdata",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/fee-bind-station",
    //   name: "企业费率-关联站点",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-manage/children/fee-bind-station/fee-bind-station.vue"
    //     ),
    //   meta: {
    //     nameKey: "feeBindStation",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-manage/fee-bind-station-list",
    //   name: "企业费率-关联站点列表",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-manage/children/fee-bind-station-list/fee-bind-station-list.vue"
    //     ),
    //   meta: {
    //     nameKey: "feeBindStationList",
    //   },
    // },
    {
        path: "/pile-manage/sim-manage",
        name: "SIM卡管理",
        component: () => import("@/views/pile-manage/sim-manage/sim-manage.vue"),
        children: [
        // {
        //   path: "/pile-manage/sim-manage/edit-sim",
        //   name: "编辑SIM卡",
        //   component: () =>
        //     import("@/views/pile-manage/sim-manage/children/edit-sim.vue"),
        //   meta: {
        //     nameKey: "editSim",
        //   },
        // },
        // {
        //   path: "/pile-manage/sim-manage/details-sim",
        //   name: "SIM卡详情",
        //   component: () =>
        //     import("@/views/pile-manage/sim-manage/children/details-sim.vue"),
        //   meta: {
        //     nameKey: "detailsSim",
        //   },
        // },
        // {
        //   path: "/pile-manage/sim-manage/add-sim",
        //   name: "新增SIM卡",
        //   component: () =>
        //     import("@/views/pile-manage/sim-manage/children/add-sim.vue"),
        //   meta: {
        //     nameKey: "addSim",
        //   },
        // },
        ],
    },
    {
        path: "/pile-manage/pile-power",
        name: "站点功率统计",
        component: () => import("@/views/pile-manage/pile-power/pile-power.vue"),
        meta: {
            nameKey: "pilePower",
        },
    },
    {
        path: "/pile-manage/floor-lock",
        name: "地锁管理",
        component: () => import("@/views/pile-manage/floor-lock/floor-lock.vue"),
        children: [
            {
                path: "/pile-manage/floor-lock/add",
                name: "新增地锁",
                component: () => import("@/views/pile-manage/floor-lock/children/add-floor-lock/add-floor-lock.vue"),
                meta: {
                    nameKey: "addFloorLock",
                },
            },
            {
                path: "/pile-manage/floor-lock/edit",
                name: "修改地锁",
                component: () => import("@/views/pile-manage/floor-lock/children/edit-floor-lock/edit-floor-lock.vue"),
                meta: {
                    nameKey: "editFloorLock",
                },
            },
            {
                path: "/pile-manage/floor-lock/config",
                name: "配置地锁",
                component: () => import("@/views/pile-manage/floor-lock/children/config-floor-lock/config-floor-lock.vue"),
                meta: {
                    nameKey: "configFloorLock",
                },
            },
        ],
    },
    // {
    //   path: "/pile-manage/delay-fee-manage",
    //   name: "占桩费率管理",
    //   component: () =>
    //     import("@/views/pile-manage/delay-fee-manage/delay-fee-manage.vue"),
    // },
    // {
    //   path: "/pile-manage/delay-fee-manage/add",
    //   name: "新增占桩费率",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/delay-fee-manage/children/add-fee/add-fee.vue"
    //     ),
    //   meta: {
    //     nameKey: "delayFeeAdd",
    //   },
    // },
    // {
    //   path: "/pile-manage/delay-fee-manage/updata",
    //   name: "修改占桩费率",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/delay-fee-manage/children/delay-edit-fee/delay-edit-fee.vue"
    //     ),
    //   meta: {
    //     nameKey: "delayFeeUpdata",
    //   },
    // },
    // {
    //   path: "/pile-manage/delay-fee-manage/count",
    //   name: "占桩费率使用数量",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/delay-fee-manage/children/count-detail/count-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "delayCountDetail",
    //   },
    // },
    // {
    //   path: "/pile-manage/delay-fee-manage/details",
    //   name: "占桩费率详情",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/delay-fee-manage/children/delay-fee-detail/delay-fee-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "delayFeeDetails",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-details",
    //   name: "费率应用明细",
    //   component: () => import("@/views/pile-manage/fee-details/fee-details.vue"),
    // },
    // {
    //   path: "/pile-manage/fee-details/details",
    //   name: "交直流充电桩充电费率",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/fee-details/children/fee-detail/fee-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "feePileDetail",
    //   },
    // },
    // {
    //   path: "/pile-manage/fee-details/sta-details",
    //   name: "费率详情",
    //   component: () =>
    //     import("@/views/pile-manage/fee-details/children/details/details.vue"),
    //   meta: {
    //     nameKey: "feeDetails",
    //   },
    // },
    {
        path: "/pile-manage/release-details/rate",
        name: "费率下发明细",
        component: () => import("@/views/pile-manage/release-details-rate/release-details-rate.vue"),
    },
    {
        path: "/pile-manage/release-details/qr-code",
        name: "二维码下发明细",
        component: () => import("@/views/pile-manage/release-details-qrcode/release-details-qrcode.vue"),
    },
    // {
    //   path: "/pile-manage/qrderly-charging/power-sharing",
    //   name: "功率均分策略",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/power-sharing/power-sharing.vue"
    //     ),
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/power-sharing/count",
    //   name: "有序充电功率均分策略应用数量充电",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/power-sharing/children/count-detail/count-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "qrderlyChargingCount",
    //   },
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/power-sharing/add",
    //   name: "新增有序充电功率均分策略",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/power-sharing/children/add/add.vue"
    //     ),
    //   meta: {
    //     nameKey: "qrderlyChargingAdd",
    //   },
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/power-sharing/updata",
    //   name: "修改有序充电功率均分策略",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/power-sharing/children/add/add.vue"
    //     ),
    //   meta: {
    //     nameKey: "qrderlyChargingUpdata",
    //   },
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/first-come",
    //   name: "先到先充策略",
    //   component: () =>
    //     import("@/views/pile-manage/qrderly-charging/first-come/first-come.vue"),
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/first-come/count",
    //   name: "有序充电先到先充策略应用数量",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/first-come/children/count-detail/count-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "qrderlyChargingFirstComeCount",
    //   },
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/first-come/add",
    //   name: "新增有序充电先到先充策略",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/first-come/children/add-first-come/add-first-come.vue"
    //     ),
    //   meta: {
    //     nameKey: "qrderlyChargingFirstComeAdd",
    //   },
    // },
    // {
    //   path: "/pile-manage/qrderly-charging/first-come/updata",
    //   name: "修改有序充电先到先充策略",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/qrderly-charging/first-come/children/add-first-come/add-first-come.vue"
    //     ),
    //   meta: {
    //     nameKey: "qrderlyChargingFirstComeUpdata",
    //   },
    // },
    // {
    //   path: "/pile-manage/reservation-rate",
    //   name: "预约费率管理",
    //   component: () =>
    //     import("@/views/pile-manage/reservation-rate/reservation-rate.vue"),
    // },
    // {
    //   path: "/pile-manage/reservation-rate/add-fee",
    //   name: "新增预约费率管理",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/reservation-rate/children/add-fee/add-fee.vue"
    //     ),
    //   meta: {
    //     nameKey: "addReservationRate",
    //   },
    // },
    // {
    //   path: "/pile-manage/reservation-rate/edit-fee",
    //   name: "修改预约费率管理",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/reservation-rate/children/edit-fee/edit-fee.vue"
    //     ),
    //   meta: {
    //     nameKey: "updataReservationRate",
    //   },
    // },
    // {
    //   path: "/pile-manage/reservation-rate/count",
    //   name: "预约费率使用站点",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/reservation-rate/children/count-detail/count-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "reservationRateCount",
    //   },
    // },
    // {
    //   path: "/pile-manage/reservation-rate/fee-pile-detail",
    //   name: "预约费率详情",
    //   component: () =>
    //     import(
    //       "@/views/pile-manage/reservation-rate/children/fee-pile-detail/fee-pile-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "detailsReservationRate",
    //   },
    // },
    {
        path: "/pile-manage/msg-manage",
        name: "短信管理",
        component: () => import("@/views/pile-manage/msg-manage/msg-manage.vue"),
        children: [
            {
                path: "/pile-manage/msg-manage/msg-server/msg-recharge",
                name: "短信条数充值",
                component: msgRecharge,
                meta: {
                    nameKey: "msgRecharge",
                },
            },
            {
                path: "/pile-manage/msg-manage/msg-server/msg-buy",
                name: "短信购买",
                meta: {
                    nameKey: "msgBuy",
                },
                component: msgBuy,
            },
            {
                path: "/pile-manage/msg-manage/msg-buy-record/details",
                name: "短信购买记录详情",
                component: msgBuyRecordDetails,
                meta: {
                    nameKey: "msgBuyRecordDetails",
                },
            },
            {
                path: "/pile-manage/msg-manage/msg-buy-record/msg-purchase",
                name: "短信购买",
                component: msgPurchase,
                meta: {
                    nameKey: "msgPurchase",
                },
            },
            {
                path: "/pile-manage/msg-manage/msg-buy-record/msg-apply-invoice",
                name: "申请发票",
                component: msgApplyInvoice,
                meta: {
                    nameKey: "msgApplyInvoice",
                },
            },
        ],
    },
];
export default routerList;
